import { all, fork } from "redux-saga/effects";

import { componentSaga } from "@app/component/componentSaga";
import { sceneSaga } from "@app/scene/sceneSaga";

import { activitySaga } from "./activity/sagas";
import { announcementsSaga } from "./announcements/sagas";
import { appSaga } from "./app/sagas";
import { authSaga } from "./auth/sagas";
import { boundaryLegendsSagas } from "./boundaryLegends/sagas";
import { chatSaga } from "./chat/sagas";
import { companySaga } from "./company/sagas";
import { cumulSaga } from "./cumul/sagas";
import { customFieldsSaga } from "./customFields/sagas";
import { dealSaga } from "./deal/sagas";
import { dealLossReasonsSaga } from "./dealLossReasons/sagas";
import { emailSaga } from "./email/saga";
import { entityAddressSaga } from "./entityAddress/sagas";
import { entityViewSaga } from "./entityView/sagas";
import { errorsSaga } from "./errors/sagas";
import { exportEntitiesSaga } from "./exportEntities/sagas";
import { fieldInsightsSagas } from "./fieldInsights/sagas";
import { fieldInsightsChartSummarySaga } from "./fieldInsightsChartSummary/sagas";
import { fieldInsightsChartVisibilitySaga } from "./fieldInsightsChartVisibility/sagas";
import { filesSaga } from "./files/sagas";
import { fileTagsSaga } from "./fileTags/sagas";
import { frequencySaga } from "./frequency/saga";
import { globalSearchSaga } from "./globalSearch/sagas";
import { groupsSaga } from "./groups/sagas";
import { iamSaga } from "./iam/sagas";
import { integrationsSaga } from "./integrations/sagas";
import { layoutSaga } from "./layout/sagas";
import { localeSaga } from "./locale/sagas";
import { locationSaga } from "./location/sagas";
import { mapLayersSagas } from "./mapLayers/sagas";
import { mapLegendsSagas } from "./mapLegends/sagas";
import { membersSaga } from "./members/sagas";
import { notificationSaga } from "./notification/sagas";
import { nylasSaga } from "./nylas/sagas";
import { onboardingSaga } from "./onboarding/sagas";
import { personSaga } from "./person/sagas";
import { pinLegendsSagas } from "./pinLegends/sagas";
import { recordPreviewSaga } from "./recordPreview/sagas";
import { referenceDataSaga } from "./referenceData/sagas";
import { resourcesSaga } from "./resources/saga";
import { routesSaga } from "./routes/saga";
import { savedFiltersSaga } from "./savedFilters/sagas";
import { schemaSaga } from "./schema/sagas";
import { stackRankSaga } from "./stackRank/sagas";
import { territoriesSaga } from "./territories/sagas";
import { themeSaga } from "./theme/sagas";
import { uiSyncSaga } from "./uiSync/sagas";
import { userColorSaga } from "./userColor/sagas";

// Read more about root saga patterns: https://redux-saga.js.org/docs/advanced/RootSaga.html
export function* rootSaga() {
  yield all([
    fork(activitySaga),
    fork(announcementsSaga),
    fork(appSaga),
    fork(authSaga),
    fork(boundaryLegendsSagas),
    fork(chatSaga),
    fork(companySaga),
    fork(componentSaga),
    fork(cumulSaga),
    fork(customFieldsSaga),
    fork(dealLossReasonsSaga),
    fork(dealSaga),
    fork(emailSaga),
    fork(entityAddressSaga),
    fork(entityViewSaga),
    fork(errorsSaga),
    fork(exportEntitiesSaga),
    fork(fieldInsightsChartSummarySaga),
    fork(fieldInsightsChartVisibilitySaga),
    fork(fieldInsightsSagas),
    fork(filesSaga),
    fork(fileTagsSaga),
    fork(frequencySaga),
    fork(globalSearchSaga),
    fork(groupsSaga),
    fork(iamSaga),
    fork(integrationsSaga),
    fork(layoutSaga),
    fork(localeSaga),
    fork(locationSaga),
    fork(mapLayersSagas),
    fork(mapLegendsSagas),
    fork(membersSaga),
    fork(notificationSaga),
    fork(nylasSaga),
    fork(onboardingSaga),
    fork(personSaga),
    fork(pinLegendsSagas),
    fork(recordPreviewSaga),
    fork(referenceDataSaga),
    fork(resourcesSaga),
    fork(routesSaga),
    fork(savedFiltersSaga),
    fork(sceneSaga),
    fork(schemaSaga),
    fork(stackRankSaga),
    fork(territoriesSaga),
    fork(themeSaga),
    fork(uiSyncSaga),
    fork(userColorSaga),
  ]);
}
